import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Self,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-input-chips',
  templateUrl: './input-chips.component.html',
  styleUrls: ['./input-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputChipsComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() public inputLabel: string;
  @Input() public testId: string;
  @Input() public shouldShowChips = true;
  @Input() public numeric = false;

  @Input()
  get maxLength(): number {
    return this._maxLength || null;
  }
  set maxLength(value: number) {
    this._maxLength = value;
  }

  private _maxLength: number;

  public items: string[] = [];
  public itemsControl = new FormControl('');

  private ngUnsubscribe = new Subject();

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    @Self() @Optional() public ctrl: NgControl,
    private cd: ChangeDetectorRef,
  ) {
    if (this.ctrl) {
      this.ctrl.valueAccessor = this;
    }
  }

  public ngOnInit(): void {
    this.itemsControl.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(items => {
        const itemsArr = items
          .split(/,\s*/)
          .map(v => v[v.length - 1] === ',' ? v.slice(0, -1) : v)
          .filter(v => !!v);

        if (items[items.length - 1] === ',' || itemsArr.length > 1) {
          this.setItems(itemsArr);
        }
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {
    if (!value?.length) {
      this.items = [];
      this.cd.markForCheck();
    }
  }

  public onRemoveItem(item: string): void {
    this.items = this.items.filter(v => v !== item);
    this.ctrl.control.setValue(this.items);
  }

  public onEnterKeyup(items: string): void {
    if (items?.length) {
      this.setItems([items]);
    }
  }
  public onBlur(items: string): void {
    if (items?.length) {
      this.setItems([items]);
    }
  }

  private setItems(itemsArr: string[]) {
    this.items = [...new Set([...this.items, ...itemsArr])];
    this.itemsControl.reset('', { emitEvent: false });
    this.ctrl.control.setValue(this.items);
  }
}
